import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "tabContainer" }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { class: "d-flex mb_10" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "inputContainer tinyMceContainer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_tiny_mce_view = _resolveComponent("tiny-mce-view")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.titleKey)
        ? (_openBlock(), _createBlock(_component_localized_text, {
            key: 0,
            localizedKey: _ctx.titleKey,
            text: _ctx.titleValue,
            class: "input_title"
          }, null, 8, ["localizedKey", "text"]))
        : (_openBlock(), _createElementBlock("span", _hoisted_2)),
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.locales, (langTab, i) => {
          return (_openBlock(), _createElementBlock("div", {
            class: _normalizeClass(["tab", _ctx.selectedLocale == langTab ? 'active' : '']),
            key: i,
            onClick: ($event: any) => (_ctx.setInputLocale(langTab))
          }, _toDisplayString(langTab), 11, _hoisted_4))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_tiny_mce_view, {
        modelValue: _ctx.selectedInput,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedInput) = $event))
      }, null, 8, ["modelValue"])
    ])
  ]))
}